import React from 'react';
import PropTypes from 'prop-types';
import { t } from 'i18next';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import Input from '@components/Input';
import {
  StringsList,
  StringRow,
  RemoveStringButton,
  AddStringButton,
} from './styles';

// Renders the "Multiple" mode's editable list of custom strings, with per-row remove and a
// trailing add button. Extracted out of CustomConfig so the parent only has to wire up the
// customTexts array + the three update/add/remove callbacks.
const CustomTextsList = ({ texts, onChangeAt, onAdd, onRemoveAt }) => (
  <StringsList className="customTextsList">
    {texts.map((text, index) => (
      <StringRow key={index} className="customTextRow">
        <Input
          className="stimulusTextInput"
          value={text}
          onChange={onChangeAt(index)}
          width={390}
          height={44}
        />
        <RemoveStringButton
          type="button"
          className="removeStringButton"
          title={t('Stimuli.removeString')}
          aria-label={t('Stimuli.removeString')}
          onClick={onRemoveAt(index)}
          disabled={texts.length <= 1}
        >
          <DeleteOutlinedIcon color="error" sx={{ fontSize: 20 }} />
        </RemoveStringButton>
      </StringRow>
    ))}
    <AddStringButton type="button" className="addStringButton" onClick={onAdd}>
      <AddCircleOutlineIcon sx={{ fontSize: 18 }} />
      {t('Stimuli.addString')}
    </AddStringButton>
  </StringsList>
);

CustomTextsList.propTypes = {
  texts: PropTypes.arrayOf(PropTypes.string),
  onChangeAt: PropTypes.func,
  onAdd: PropTypes.func,
  onRemoveAt: PropTypes.func,
};

export default CustomTextsList;
